import { render, staticRenderFns } from "./XIMHGRDB.vue?vue&type=template&id=2caef01d&scoped=true&"
import script from "./XIMHGRDB.vue?vue&type=script&lang=js&"
export * from "./XIMHGRDB.vue?vue&type=script&lang=js&"
import style0 from "./XIMHGRDB.vue?vue&type=style&index=0&id=2caef01d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caef01d",
  null
  
)

export default component.exports